import { render } from "./docSearchs1.vue?vue&type=template&id=314c5ac7&scoped=true"
import script from "./docSearchs1.vue?vue&type=script&lang=js"
export * from "./docSearchs1.vue?vue&type=script&lang=js"

import "./docSearchs1.vue?vue&type=style&index=0&id=314c5ac7&lang=scss&scoped=true"

import exportComponent from "D:\\GitLocal\\mvs-sys\\mvsui-user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314c5ac7"]])

export default __exports__